export default __webpack_public_path__ + "checked-in-chime.da5744b5.mp3";